<ion-item-group>
  <ion-item-divider>
    <ion-label translate>Mobile.LocationTracking</ion-label>
  </ion-item-divider>

  <ion-item>
    <ion-toggle [checked]="locationTrackingEnabled" (ionChange)="onLocationTrackingChange($event)">
      {{ 'Mobile.LocationTrackingEnabled' | translate }}
    </ion-toggle>
  </ion-item>

  <app-settings-select-field *ngIf="distanceFilterSettings" [entry]="distanceFilterSettings" [readOnly]="readOnly">
  </app-settings-select-field>
  <app-settings-select-field *ngIf="updateIntervalSettings" [entry]="updateIntervalSettings" [readOnly]="readOnly">
  </app-settings-select-field>
</ion-item-group>
